/*
 * Make My Day product card — snippets/mm-featured-products-card.liquid.
 *
 * Shared by MM Featured Products and MMX Collection Grid. Clicks are delegated from the document, so cards revealed or
 * re-ordered later (filters, "see more", sliders) work without re-binding:
 * - Subscribe & Save / One-time purchase toggle (enables or disables the selling plan input);
 * - quantity stepper (writes the form's quantity input).
 *
 * Adding to cart is handled by the theme's <product-form>, which sets `aria-busy` on the submit button while the
 * request runs; the loading spinner is styled in assets/mm-featured-products.css.
 */
(() => {
  if (window.mmProductCardReady) {
    return;
  }

  window.mmProductCardReady = true;

  const setPricing = (option) => {
    const track = option.closest('.mm-featured-products__pricing-track');

    if (!track || track.classList.contains('mm-featured-products__pricing-track--once-only')) {
      return;
    }

    const isOnetime = option.dataset.pricing === 'onetime';
    const sellingPlanInput = track.closest('.mm-featured-products__card')?.querySelector('.mm-featured-products__selling-plan-input');

    track.classList.toggle('is-onetime', isOnetime);
    track.querySelectorAll('.mm-featured-products__pricing-opt').forEach((element) => {
      element.classList.toggle('is-active', element === option);
      element.setAttribute('aria-pressed', String(element === option));
    });

    if (sellingPlanInput) {
      sellingPlanInput.disabled = isOnetime;
    }
  };

  const stepQuantity = (button) => {
    const wrapper = button.closest('.mm-featured-products__qty');
    const card = wrapper?.closest('.mm-featured-products__card');
    const input = card?.querySelector('.mm-featured-products__qty-input');

    if (!wrapper || !input) {
      return;
    }

    const min = parseInt(wrapper.dataset.min, 10) || 1;
    const max = parseInt(wrapper.dataset.max, 10) || 99;
    const step = button.classList.contains('mm-featured-products__qty-btn--minus') ? -1 : 1;
    const quantity = Math.min(max, Math.max(min, (parseInt(input.value, 10) || min) + step));

    const minus = wrapper.querySelector('.mm-featured-products__qty-btn--minus');
    const plus = wrapper.querySelector('.mm-featured-products__qty-btn--plus');

    input.value = quantity;
    wrapper.querySelector('.mm-featured-products__qty-val').textContent = quantity;
    minus.disabled = quantity <= min;
    plus.disabled = quantity >= max;

    // A button that just got disabled drops keyboard focus, so hand it to the other one
    if (button.disabled) {
      (button === minus ? plus : minus).focus();
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;

    if (!target) {
      return;
    }

    const option = target.closest('.mm-featured-products__pricing-opt');
    if (option) {
      setPricing(option);
      return;
    }

    const quantityButton = target.closest('.mm-featured-products__qty-btn');
    if (quantityButton) {
      stepQuantity(quantityButton);
    }
  });
})();
